export const LISTE_REGROUPEMENT_PRODUIT = {
  title: 'Liste des regroupements produit',
  breadcrumb: {
    racine: 'Accueil',
    liste: 'Liste des regroupements produit',
  },
  actions: {
    add: 'Nouveau regroupement',
  },
  tabs: {
    code: 'Code',
    libelle: 'Libellé',
    marche: 'Marché',
    fournisseur: 'Fournisseur',
  },
  filtre: {
    code: 'Code',
    libelle: 'Libellé',
  },
  popUpSuppression: {
    title: 'Êtes-vous sûr de vouloir supprimer ce regroupement de produits ?',
    sucessDelete: 'Regroupement de produits supprimé avec succès.',
  },
};

export const EDITION_REGROUPEMENT_PRODUIT = {
  title: {
    add: 'Création d\'un regroupement de produit',
    edit: 'Modification du regroupement de produit',
  },
  breadcrumb: {
    add: 'Création regroupement produit',
    edit: 'Modification regroupement produit',
    racine: 'Accueil',
    liste: 'Liste des regroupements de produit',
  },
  tabs: {
    informations: 'Regroupement',
    produits: 'Produits',
    regleCommission: 'Règle commission',
    objectifVente: 'Objectif vente',
    reglesAchat: 'Règle d\'achat',
    cgv: 'C.G.V',
  },
  validation: {},
  information: {
    title: 'Informations générales',
    code: 'Code',
    libelle: 'Libellé',
  },
  informationProduits: {
    title: 'Informations produits',
    assistant: 'Assistant(e)',
  },
  produits: {
    tab: {
      reference: 'Référence',
      type: 'Type',
      label: 'Libellé',
      actif: 'Archivé',
    },
    addProduct: 'Ajouter un produit',
  },
  notifications: {
    successCreation: 'Création du regroupement de produit réalisée avec succès.',
    successChange: 'Modification du regroupement de produit réalisée avec succès.',
  },
  error: {
    champsObligatoire: 'Le champs {name} est obligatoire',
    productIncludeInRegroupement: 'Le produit {name} est déjà relié à un regroupement',
  },
  bMessage: {
    info: 'Information',
    infoMsg: 'Il n\'y a pas de produit dans ce regroupement. Les informations de regroupement seront grisées',
  },
};

export const DETAIL_REGROUPEMENT_PRODUIT = {
  title: 'Détail du regroupement produit {libelle}',
  breadcrumb: {
    detail: 'Détail du regroupement produit',
    racine: 'Accueil',
    liste: 'Liste des regroupements de produit',
  },
  tabs: {
    informations: 'Regroupement',
    produits: 'Produits',
    regleCommission: 'Règle commission',
    objectifVente: 'Objectif vente',
    reglesAchat: 'Règle d\'achat',
    cgv: 'C.G.V',
  },
};

export const AJOUT_PRODUIT_SUR_REGROUPEMENT = {
  title: 'Ajouter un produit',
  table: {
    reference: 'Référence',
    type: 'Type',
    libelle: 'Libellé',
    actif: 'Archivé',
  },
  filtre: {
    reference: 'Référence(s)',
    libelle: 'Libellé(s)',
    actif: 'Actif',
    avecLiaisons: 'Avec liaisons',
    categorie: 'Catégorie',
  },
};
